import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    validateAdviser,
    validateAppointmentType,
    validateDate,
    validateEndTime,
    validateLocation,
    validateRemoteCallUrl,
    validateStartTime
} from '../../validation/validationFunctions';

export const validate = (newEntry) => {
    let newErrors = {};

    newErrors = validateAppointmentType(newEntry.typeId, newErrors);
    newErrors = validateLocation(newEntry.locationId, newErrors);
    newErrors = newEntry.remoteCallUrl
        ? validateRemoteCallUrl(newEntry.remoteCallUrl, newErrors)
        : newErrors;
    newErrors = validateAdviser(newEntry.userId, newErrors);
    newErrors = validateStartTime(newEntry.startTime, newEntry.endTime, newErrors);
    newErrors = validateEndTime(newEntry.endTime, newEntry.startTime, newErrors);
    newErrors = validateDate(newEntry.date, newErrors);

    return newErrors;
};

export const validateDiff = (payload, initial) => checkDiff(payload, initial);
